module.exports = __webpack_public_path__ + "static/noise-gradient-48f139ae482f36678c6f1510bcff8cda.png";